import {Component, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DashboardService} from '../../../../service/events/dashboard.service';
import {ClientesApiService} from '../../../../service/api/clientes-api.service';
import {BaseForm} from '../../../base-form';
import {build, stack} from '../../../../common/classes/request-builder';
import {UsuariosApiService} from '../../../../service/api/usuarios-api.service';
import {FormRequestTypes} from '../../../../common/classes/form-request';
import { environment } from '../../../../../environments/environment';
import { RequestButtonComponent } from '../../../../common/components/request-button/request-button.component';
import { UploadApiService } from '../../../../service/api/upload-api.service';
import { RopoApiService } from '../../../../service/api/ropo-api.service';
import { firstValueFrom, Subject } from 'rxjs';

import type { OnInit } from '@angular/core';
import { ClienteModel } from '../../../../models/cliente.model';
import { UserModel } from '../../../../models/usuarios/user.model';
import { ClientesFormDefinition } from './form-definition';
import { ClientesEnvironmentDefinition } from '../environment-variables';
import { ClientesListsDefinition } from './list-variables';
import { EventPhase, FormPhase } from '../../../../common/components/reactive-form-builder/form-request';
import { ReactiveFormBuilderComponent } from '../../../../common/components/reactive-form-builder/form-builder.component';
import { HttpClient } from '@angular/common/http';
@Component({
    selector: 'app-clientes-form',
    standalone: false,
    templateUrl: './clientes-form.component.html',
    styleUrls: ['./clientes-form.component.scss']
})
export class ClientesFormComponent extends BaseForm<ClienteModel> implements OnInit {

    @ViewChild(RequestButtonComponent, { read: RequestButtonComponent, static: true })
        requestButton = new RequestButtonComponent<ClienteModel>();
    public form!: ClientesFormDefinition;
    public formRequest = new ReactiveFormBuilderComponent(this.http);
    public env: ClientesEnvironmentDefinition = new ClientesEnvironmentDefinition();
    public lists: ClientesListsDefinition = new ClientesListsDefinition();

    public override model = {} as ClienteModel;
    public hasClienteError = '';
    public dropdownLoadTrigger = new Subject<void>();

    constructor(public override router: Router,
        public override route: ActivatedRoute,
        public override dashboard: DashboardService,
        public usuariosApi: UsuariosApiService,
        public clientesApi: ClientesApiService,
        public _ropoService: RopoApiService,
        private http: HttpClient,
        public uploadApi: UploadApiService) {
        super(
            route,
            router,
            dashboard,
            clientesApi.clientesPUT,
            clientesApi.clientesPOST,
            'clientes',
            'Editar ' + environment.features.clienteName,
            'Crear ' + environment.features.clienteName,
            'Duplicar ' + environment.features.clienteName
        );

    }

    ngOnInit() {
        this.form = new ClientesFormDefinition(
                    this.getType(),
                    this.getModel() as Record<string,string>,
                    null
                );
        this.expandFormRequest();
        this.formRequest.executePhase(FormPhase.LOAD);
        this.softInit(this.getType());
        this.form.model = this.model;
    }

    public validate(tag?: string) {
        if ((tag === 'nif') && this.getType() === FormRequestTypes.CREATE) {
            const nifSearch = ((this.model || {}).nif || '').toLowerCase();

            if ((nifSearch || '').length === 0) {
                return true;
            }


            const existeNif = (this.lists.clientes.values || [])
                .filter(it => it && it.value)
                .map(it => it.value)
                .find((nif) => (nif.nif || '').toLowerCase() === nifSearch);

            if (existeNif) {
                this.hasClienteError = 'El cliente ya existe';
            } else {
                this.hasClienteError = '';
            }

            return !existeNif;
        }

        return true;
    }

    public formChanges(formModel: any, tag: string) {
        this.form.model = formModel;
        this.validate(tag);
        
        // Cálculo automático del REGEPA al introducir DNI si tiene activada esa funcionalidad
        if ( tag === 'nif' && this.env.showRopoRomaRegepa && (this.form.model.nif as string).length >= 9 ){

            (firstValueFrom(this._ropoService.getREGEPA(this.form.model.nif ?? '')))
                .then( (resp) => {
                    const regepa = resp.regepa;
                    if ( Object.keys(regepa).length !== 0 ) {
                        this.form.model.regepa = regepa.código;

                    } 
                    return;
                })
                .catch( (error: string) => console.log('error', error)
                );            
        } 

    }

   
    private expandFormRequest() {
        // NO CHANGE STACK BY POOL IN THAT CASE!!
        this.formRequest.addEvent(FormPhase.LOAD, EventPhase.BEFORE, (resolve) => {            
            stack([
                build(
                    this.usuariosApi.usuariosGET, 
                    this.lists.usuarios, ((it: UserModel) => (it.nombre || '') + ' ' + (it.apellidos || '')), 
                    true
                ),  
                build(this.clientesApi.clientesGET, this.lists.clientes, 'nombre', true)
            ]).then(() => {
                this.dropdownLoadTrigger.next();
                resolve(true);
                return;
            }).catch (e => {
                console.log('catch en getPosition: ' + e);
            }
            );
        });

        this.formRequest.addEvent(FormPhase.SEND, EventPhase.BEFORE, (resolve) => {
            if (this.getType() === FormRequestTypes.CREATE) {
                resolve(this.validate('nif'));
            } else {
                resolve(true);
            }
        });
    }
}
